import { JumpToModule } from './../../../widgets/jump-to/jump-to.module';
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import {
  DxChartModule,
  DxAutocompleteModule,
  DxDataGridModule,
  DxPopupModule,
  DxDropDownButtonModule,
  DxSwitchModule,
} from "devextreme-angular";
import { CommonModule } from "@angular/common";
import { DevEpressCommonModule } from "src/app/dev-epress-common.module";
import { ForecastDetailedPostingsComponent } from "./forecast-detailed-postings.component";
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';

@NgModule({
  imports: [
    CommonModule,

		JumpToModule,
		HelpButtonComponent,
		DxTableControllerDirective,

    DxChartModule,
    DxAutocompleteModule,
    DxDataGridModule,
    DevEpressCommonModule,
    DxPopupModule,
    DxDropDownButtonModule,DxSwitchModule,
    RouterModule.forChild([
      {
        path: "",
        component: ForecastDetailedPostingsComponent,
      },
      {
        path: ":id",
        component: ForecastDetailedPostingsComponent,
      },
    ]),
  ],
  declarations: [ForecastDetailedPostingsComponent],
})
export class ForecastDetailedPostingsModule {}
